<template>
    <vx-card>
        <vs-table id="table" pagination search class="my-5" no-data-text="لا يوجد مدراء" :data="admins" :total="admins.length">

            <div slot="header">
              <template v-if="hasRole('add_roles')">
                <vs-button @click="openForm('assign')" class="mt-4 md:mt-0 sm:ml-3 w-full sm:w-auto">تعيين صلاحيات لإستاذ</vs-button>
                <vs-button @click="openForm('add')" color="success" class="mt-4 md:mt-0 sm:ml-3 w-full sm:w-auto">إنشاء حساب جديد</vs-button>
              </template>
            </div>

            <template slot="thead">
                <vs-th class="w-40" sort-key="first_name">الإسم</vs-th>
                <vs-th class="w-40" sort-key="middle_name">إسم الأب</vs-th>
                <vs-th class="w-40" sort-key="last_name">إسم اللقب</vs-th>
                <vs-th class="w-40" sort-key="email">البريد الإلكتروني</vs-th>
                <vs-th class="lg:block hidden" sort-key="roles">الصلاحيات</vs-th>
                <vs-th>العمليات</vs-th>
            </template>

            <tbody slot-scope="{data}">
            <vs-tr v-for="(tr, index) in data" :data="tr" :key="index">
                <vs-td :data="tr.first_name">{{ tr.first_name }}</vs-td>
                <vs-td :data="tr.middle_name">{{ tr.middle_name }}</vs-td>
                <vs-td :data="tr.last_name">{{ tr.last_name }}</vs-td>
                <vs-td :data="tr.email">
                  <div class="flex items-center">
                    {{ tr.email }}
                    <vx-tooltip :text="tr.is_verified ? 'البريد الإلكتروني مؤكد' : 'البريد الإلكتروني غير مؤكد'" class="cursor-pointer ml-2">
                      <vs-icon :icon="tr.is_verified ? 'icon-check' : 'icon-x'" icon-pack="feather"
                               :class="tr.is_verified ? 'bg-success' : 'bg-danger'"
                               class="rounded-full p-px h-3 w-3 text-white"/>
                    </vx-tooltip>
                  </div>
                </vs-td>
                <vs-td class="lg:block hidden" :data="tr.roles">{{ roles(tr.roles).join(', ') }}</vs-td>
                <vs-td>
                    <div class="flex">
                        <vs-button v-if="hasRole('update_roles')" @click="openForm('edit', tr)" class="mr-2" title="تعديل" size="large" icon="icon-edit" icon-pack="feather" type="flat"/>
                        <vs-button v-if="hasRole('delete_roles')" @click="deleteAdmin(tr)" size="large" title="إزالة" color="danger" type="flat" icon-pack="feather" icon="icon-x"></vs-button>
                    </div>
                </vs-td>
            </vs-tr>
            </tbody>

        </vs-table >

        <user-role-form @submit="save" :type="formType" :data="userData" :active.sync="isFormActive" />
    </vx-card>
</template>

<script>
    import adminsAPI from '@/api/admin/adminsAPI'
    import UserRoleForm from "./UserRoleForm";

    export default {
        components: { UserRoleForm },
        data() {
            return {
                admins: [],
                isFormActive: false,
                formType: 'add',
                userData: {}
            }
        },
        methods: {
            roles(roles){
                return roles.map(role => {
                    role = role.split('_')
                    let roleText = ''
                    switch (role[0].toLowerCase()) {
                        case 'view': roleText += 'عرض '; break
                        case 'add': roleText += 'إضافة '; break
                        case 'assign': roleText += 'تعيين '; break
                        case 'update': roleText += 'تعديل '; break
                        case 'delete': roleText += 'حذف '; break
                        default: roleText += ''
                    }
                    switch (role[1].toLowerCase()) {
                        case 'students': roleText += 'الطلبة'; break
                        case 'teachers': roleText += 'الأساتذة'; break
                        case 'courses': roleText += 'المواد الدراسية'; break
                        case 'roles': roleText += 'الصلاحيات'; break
                        case 'terms': roleText += 'الفصول الدراسية'; break
                        default: roleText += ''
                    }
                    return roleText
                })
            },
            deleteAdmin(admin){
                let message =  `هل انت متأكد بأنك تريد إزالة حساب المدير من الكلية ${admin.first_name} ${admin.last_name}`
                this.$confirmAlert(null, message, () => {
                    adminsAPI.delete(admin.id)
                        .then(response => {
                            this.admins.splice(this.admins.indexOf(admin), 1)
                            this.$notifySuccess(response.successMessage)
                        })
                        .catch(response => this.$notifyError(response.statusMessage))
                })
            },
            openForm(type, user = {}){
                this.userData = user
                this.formType = type
                this.isFormActive = true
            },
            save(data) {
                this.formType !== 'edit' ? this.admins.push(data) :
                    this.admins.find(admin => data.id === admin.id).roles = data.roles
            },
            loadData(){
                this.$startLoading('#table', 'white')
                adminsAPI.getAll().then(({data}) => {
                    this.admins = data.admins
                }).finally(() => this.$closeLoading('#table'))

            }
        },
        mounted(){
            this.loadData()
        }
    }

</script>
